export const routes = {
    // Authentication routes
    'login': { path: '/login', title: 'Login' },
    'forgot-password': { path: '/forgot-password', title: 'Recuperar Senha' },
    'reset-password': { path: '/reset-password/:token', title: 'Redefinir Senha' },

    // Dashboard routes
    'home': { path: '/dashboard', title: 'Dashboard' },

    // Sales routes
    'sales-flow': { path: '/sales/flow', title: 'Fluxo de Vendas' },
    'new-sale': { path: '/sales/new', title: 'Nova Venda' },
    'sale-details': { path: '/sales/:id', title: 'Detalhes da Venda' },
    'proposals': { path: '/sales/proposals', title: 'Propostas' },
    'contracts': { path: '/sales/contracts', title: 'Contratos' },

    // Virtual Model routes
    'virtual-model': { path: '/virtual-model', title: 'Maquete Virtual' },
    'unit-calendar': { path: '/units/:unitId/calendar', title: 'Calendário de Disponibilidade' },

    // Inventory routes
    'inventory': { path: '/inventory', title: 'Estoque' },

    // Financial routes
    'financial': { path: '/financial', title: 'Financeiro' },
    'payments': { path: '/financial/payments', title: 'Pagamentos' },
    'commissions': { path: '/financial/commissions', title: 'Comissões' },

    // Customer routes
    'customers': { path: '/customers', title: 'Clientes' },
    'customer-details': { path: '/customers/:id', title: 'Detalhes do Cliente' },

    // Backoffice routes
    'backoffice': { path: '/backoffice', title: 'Backoffice' },
    'campaigns': { path: '/backoffice/campaigns', title: 'Campanhas' },
    'apply-campaign': { path: '/backoffice/campaigns/apply', title: 'Aplicar Campanha' },

    // Reports routes
    'reports': { path: '/reports', title: 'Relatórios' },
    'sales-report': { path: '/reports/sales', title: 'Relatório de Vendas' },

    // User routes
    'profile': { path: '/profile', title: 'Meu Perfil' },
    'notifications': { path: '/notifications', title: 'Notificações' },

    // Schedule routes
    'schedule': { path: '/schedule', title: 'Agenda' },
    'appointment-details': { path: '/schedule/:id', title: 'Detalhes do Agendamento' },
    'contract-details': { path: '/contracts/:id', title: 'Detalhes do Contrato' },
    'meeting-details': { path: '/meetings/:id', title: 'Detalhes da Reunião' },

    // Customer Portal routes
    'customer-portal': { path: '/portal', title: 'Portal do Cliente' },
    'customer-properties': { path: '/portal/properties', title: 'Minhas Propriedades' },
    'customer-reservations': { path: '/portal/reservations', title: 'Minhas Reservas' },
    'customer-payments': { path: '/portal/payments', title: 'Meus Pagamentos' },
    'customer-documents': { path: '/portal/documents', title: 'Documentos' }
};

export default routes;